/**
 * KBG v2 — Extras: feature carousel
 */
(function () {
  'use strict';

  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function getSlideTitle(slide) {
    var eyebrow = slide.querySelector('.eyebrow');
    var heading = slide.querySelector('h3');
    if (eyebrow && eyebrow.textContent.trim()) return eyebrow.textContent.trim();
    if (heading && heading.textContent.trim()) return heading.textContent.trim();
    return '';
  }

  function updateSlideStatus(root, i) {
    var status = root.querySelector('[data-kbg-ex-status]');
    if (!status) return;
    var slides = qsa(root, '.exslide');
    var slide = slides[i];
    if (!slide) return;
    var template =
      root.getAttribute('data-ex-status') || 'Feature {current} of {total}: {title}';
    status.textContent = template
      .replace('{current}', String(i + 1))
      .replace('{total}', String(slides.length))
      .replace('{title}', getSlideTitle(slide));
  }

  function exGo(root, i) {
    var slides = qsa(root, '.exslide');
    var dots = qsa(root, '.exdot');
    if (!slides.length) return;
    i = ((i % slides.length) + slides.length) % slides.length;
    slides.forEach(function (el, x) {
      var active = x === i;
      el.setAttribute('data-active', active ? 'true' : 'false');
      if (active) {
        el.removeAttribute('hidden');
        el.setAttribute('aria-hidden', 'false');
      } else {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      }
    });
    dots.forEach(function (el, x) {
      if (x === i) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
    root.setAttribute('data-ex-index', String(i));
    updateSlideStatus(root, i);
  }

  function initSection(root) {
    var i = parseInt(root.getAttribute('data-ex-index') || '0', 10);
    exGo(root, i);
  }

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-kbg-ex-prev]');
    var next = e.target.closest('[data-kbg-ex-next]');
    var dot = e.target.closest('[data-kbg-ex-dot]');
    var root = e.target.closest('[data-kbg-extras]');
    if (!root) return;
    var cur = parseInt(root.getAttribute('data-ex-index') || '0', 10);
    if (prev) exGo(root, cur - 1);
    if (next) exGo(root, cur + 1);
    if (dot) exGo(root, parseInt(dot.getAttribute('data-kbg-ex-dot'), 10));
  });

  function initAll(scope) {
    qsa(scope || document, '[data-kbg-extras]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
